export const isParserError = r => 'object' == typeof r && null !== r && 'errid' in r
